import type { MoneyString } from '@/lib/money';

export type Severity = 'info' | 'aviso' | 'critico';

export type Notification = {
  id: number;
  uuid: string;
  entity_id: number | null;
  type: string;
  severity: Severity;
  title: string;
  body: string | null;
  action_url: string | null;
  action_label: string | null;
  amount: MoneyString | null;
  read_at: string | null;
  dismissed_at: string | null;
  created_at: string;
};

export type NotificationListResponse = {
  data: Notification[];
  meta: { total: number; last_page: number; unread: number };
};

/**
 * Catálogo vindo do backend.
 *
 * `param` diz QUAL campo o gatilho usa. Sem ele a tela mostraria antecedência
 * em dias e percentual para todos os gatilhos, e o usuário teria que adivinhar
 * qual dos dois vale para o que ele escolheu.
 */
export type TriggerInfo = {
  id: string;
  label: string;
  param: 'days_before' | 'amount_threshold' | 'percentage_threshold' | null;
  hint: string;
};

export type AlertRule = {
  id: number;
  name: string;
  trigger: string;
  entity_id: number | null;
  entity_name: string | null;
  active: boolean;
  severity: Severity;
  frequency: string;
  days_before: number | null;
  amount_threshold: MoneyString | null;
  percentage_threshold: number | null;
  account_id: number | null;
  credit_card_id: number | null;
  category_id: number | null;
  last_triggered_at: string | null;
  times_triggered: number;
};

export type AlertRuleListResponse = {
  data: AlertRule[];
  meta: { available_triggers: TriggerInfo[] };
};

export type NotificationPreference = {
  id: number;
  type: string;
  in_app: boolean;
  email: boolean;
  whatsapp: boolean;
  push: boolean;
  digest: string;
};

export const SEVERITY_STYLE: Record<Severity, { chip: string; dot: string; label: string }> = {
  critico: {
    chip: 'bg-rose-50 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300',
    dot: 'bg-rose-500',
    label: 'Crítico',
  },
  aviso: {
    chip: 'bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300',
    dot: 'bg-amber-500',
    label: 'Aviso',
  },
  info: {
    chip: 'bg-sky-50 text-sky-700 dark:bg-sky-950/40 dark:text-sky-300',
    dot: 'bg-sky-500',
    label: 'Informação',
  },
};
